export const getUser = state => state.responce.data.user;
